import { useEffect } from 'react';
import { initSocket, getSocket } from '../utils/socket';
import { apisWebsocketUrl } from '../serverLinks';

// Renders nothing. Creates the socket connection on mount, pointed at
// rb-backend-apis.
const SocketBootstrap = () => {
  useEffect(() => {
    if (!getSocket()) {
      initSocket(apisWebsocketUrl);
    }
  }, []);

  return null;
};

export default SocketBootstrap;
